import { render, staticRenderFns } from "./ViewRetail.vue?vue&type=template&id=306ae209"
import script from "./ViewRetail.vue?vue&type=script&lang=js"
export * from "./ViewRetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports